// Auto-generated build information - do not edit manually
// Generated at: 2026-04-09T09:56:27.902Z

export const buildInfo = {
  "buildNumber": "220-dev1775728587902",
  "buildDate": "2026-04-09T09:56:27.902Z",
  "gitCommit": "58a7669",
  "gitBranch": "dev",
  "gitTag": null,
  "environment": "dev"
} as const;

export type BuildInfo = typeof buildInfo;
